import { SystemField } from "./system-field";

export class Asset  extends SystemField{
    
	icon?:string;
	image?:string;
	
	ordering?:number;
	type?:string;
	edit_icon?:number;
	edit_title?:number;
	edit_subtitle?:number;
	edit_short_desc?:number;
	edit_image?:number;
	progress_value?:number;
	is_progress?:number;
	sections_id?:string; 
	parent_id?:string;
	record_type?:string;
	internal_link?:string;
	external_link?:string;
	is_external?:number;
	
	//Formula Fields
	image_file?: File;
	image_preview?:string;

	// Import class translate
   	langs?:any;
}

export class AssetTranslate  extends SystemField{
	lang_code?:string;
	assets_id?:string;
	title?:string;
	subtitle?:string;
	short_desc?:string;
	description?:string;
	exlink_title?:string;
	inlink_title?:string;
	link_target?:string;
}